var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.905,
    height: 16.131,
    viewBox: "0 0 12.905 16.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,3H16.9V4.613H4Z",
    transform: "translate(0 -0.193)",
    fill: "#533FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.679,4.42,12.259,2H9.033L6.613,4.42ZM5,6.033V16.518a1.618,1.618,0,0,0,1.613,1.613h8.066a1.618,1.618,0,0,0,1.613-1.613V6.033ZM9.033,16.518H7.42V7.646H9.033Zm4.839,0H12.259V7.646h1.613Z",
    transform: "translate(-0.193)",
    fill: "#533FFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.03e096a663482d0ec7cc6e3cd51467ff.svg";
export { ForwardRef as ReactComponent };